/* eslint-disable */
export default {
  to: '至：',
  transferTo: '转接至',
  blindTransfer: '转接',
  warmTransfer: '首先询问',
  enterNameOrNumber: '输入号码',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
